import { Component, Input } from '@angular/core';

// The Nustone "n" mark (from nustone-icon-white.svg), drawn inline so it
// takes the surrounding text colour and needs no network request.
@Component({
  selector: 'app-nustone-mark',
  standalone: true,
  template: `<svg [attr.class]="class" viewBox="0 0 48 48.4" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M44,11.7l-15-10.2c-3-2.1-7-2.1-10,0l-7.3,4.8L11.4,3c-0.2-1.6-1.5-2.6-3.2-2.6H2.8C1,0.4,0,1.4,0,3.2v41.9c0,1.8,1,3.3,2.8,3.3H9c1.8,0,3-1.5,3-3.3v-4.2V25.4v-3c0-1,0.5-1.9,1.3-2.5l9-6.3c1-0.7,2.4-0.7,3.4,0l9,6.3c0.8,0.6,1.3,1.5,1.3,2.5v3.1v15.5v2.9v1.3c0,1.8,1,3.3,2.8,3.3H45c1.8,0,3-1.5,3-3.3v-1.3V22.9c0-0.1,0-0.6,0-0.6v-3.2C48,16.2,46.5,13.4,44,11.7z" />
  </svg>`,
})
export class NustoneMarkComponent {
  @Input() class = 'h-5 w-5';
}
